export default "__VITE_ASSET__7573386e__"